import pino from "pino";

const isTestEnv = process.env.NODE_ENV === "test";

const logger = !isTestEnv
    ? pino({
          level: process.env.LOG_LEVEL || "error",
      })
    : {
          error: (error: unknown, message: string) => console.error(message, error),
          info: (info: unknown, message: string) => console.info(message, info),
          child: (object: unknown) => console.info(object),
      };

const logError = (message: string, error: unknown, meta?: object) => {
    if (meta) logger.child(meta);
    logger.error(error, message);
};

const logInfo = (message: string, info: unknown, meta?: object) => {
    if (meta) logger.child(meta);
    logger.info(info, message);
};

export { logError, logInfo };
